<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
              this.$t('report.company_dashboard.reports')
            }}
            </span>
          </li>
          <li>Kullanıcı Atama Genel Raporu</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span>Kullanıcı Atama Genel Raporu</span>
        </h2>
      </div>
    </div>
    <!--Modal Profie-->

    <!--End Modal Profile -->
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">

          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                class="uk-search-input shadow-0 uk-form-small" type="search" />
            </div>
          </div>
          <div class="d-flex">
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
              href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("sorting.a_z") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("sorting.z_a") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'id')">
                    {{ $t("sorting.created_at_old") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'id')">
                    {{ $t("sorting.created_at_new") }}</a>
                </li>
              </ul>
            </div>

            <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')"
              @download="exportContents" />

          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="user_loading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t("users.photo") }}</th>
                <th scope="col">ID</th>
                <th scope="col">Atama Adı</th>
                <th scope="col">Atamayı Oluşturan</th>
                <th scope="col">Zorunlu</th>
                <th scope="col">Atanan Kullanıcı Sayısı</th>
                <th scope="col">Başlamayan Kullanıcı Sayısı</th>
                <th scope="col">Devam Eden Kullanıcı Sayısı</th>
                <th scope="col">Tamamlayan Kullanıcı Sayısı</th>
                <th scope="col">Toplam Puan</th>
                <th scope="col">Toplam Süre</th>
                <th scope="col">Başlangıç Tarihi</th>
                <th scope="col">Bitiş Tarihi</th>
                <th scope="col">Durum</th>
                <th scope="col">Oluşturulma Tarihi</th>
              </tr>
            </thead>
            <tbody class="list">
              <template v-for="item in formattedItems">
                <tr :key="item.id">

                  <!-- Resim -->
                  <th scope="row">
                    <div class="media align-items-center">
                      <div>
                        <div class="avatar-parent-child" style="width: max-content">
                          <img :alt="item.name" :src="item.photo_link" class="avatar rounded-circle" />
                        </div>
                      </div>
                    </div>
                  </th>

                  <!-- ID -->
                  <td>{{ item.id }}</td>

                  <!-- Atama Adı -->
                  <td>{{ item.name }}</td>

                  <!-- Atamayı Oluşturan -->
                  <td>{{ item.assigner }}</td>

                  <!-- Zorunlu -->
                  <td>{{ item.is_compulsory ? "Evet" : "Hayır" }}</td>

                  <!-- Kullanıcı Sayıları -->
                  <td>{{ item.total_user }}</td>
                  <td>{{ item.not_started_users }}</td>
                  <td>{{ item.started_users }}</td>
                  <td>{{ item.completed_users }}</td>

                  <!-- Puan -->
                  <td>{{ item.total_rating }}</td>

                  <!-- Süre -->
                  <td>
                    <span style="white-space: nowrap;">
                      {{ item.total_duration }} dk
                    </span>
                  </td>
                  <!-- Tarihler -->
                  <td>{{ item.start_date }}</td>
                  <td>{{ item.end_date }}</td>

                  <!-- Durum -->
                  <td>{{ item.status }}</td>

                  <!-- Oluşturulma -->
                  <td>{{ item.created_at }}</td>

                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, {
  GET_ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import moment from "moment-timezone";
import 'moment-timezone/data/packed/latest.json'; // Loads all timezone data
import axios from "axios";
import UserFilter from "@/view/company/User/Filter";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import { showError, showInfo } from "@/utils/alertUtils";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "UserAssignmentGeneralReport",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: {
    ExcelDownloadButton,
    Pagination,
    UserFilter,
    DefaultLoading,
  },
  data() {
    return {
      pagination: null,
      activeItem: null,
      page: 1,
      per_page: 10,
      sort_by: "id",
      sort_desc: "desc",
      formattedItems: [],
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      successMessage: "",
      isReportDownloading: false
    };
  },
  computed: {
    items: {
      get() {
        return store.getters[_MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    user_loading: {
      get() {
        return store.getters[_MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    errors: {
      get() {
        return store.getters[_MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    gotoContentDetail(item) {
      this.$router.push({ name: 'company.contents.detail', params: { id: item.id } });

    },
    exportContents() {
      if (this.isReportDownloading) {
        return;
      }

      this.isReportDownloading = true;

      axios
        .get(
          process.env.VUE_APP_BACKEND_APP_URL + "/api/report/export/assignment-summaries",
          {
            params: {
              sort: this.filter.sort,
              order: this.filter.order,
              like: this.filter.search,
              report: Math.random() * 9999999,
            },
            headers: this.apiHeaders,
            responseType: "blob",
          }
        )
        .then((response) => {
          const fileURL = window.URL.createObjectURL(response.data);
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;

          const day = moment().format("YYYYMMDDHHMMSS");
          const fileName = "user_assignment_general_report_" + day + ".xlsx";

          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);

          window.URL.revokeObjectURL(fileURL);

          this.isReportDownloading = false;
        })
        .catch(() => {
          this.isReportDownloading = false;
        });
    },
    filterResult(filter = null) {
      let self = this;

      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
      };

      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/assignment-summaries",
          filters: filters,
        })
        .then((response) => {
          self.formattedItems = [];

          if (response.status) {
            let items = response.data;

            this.pagination = items;

            items.data.forEach((item) => {
              self.formattedItems.push({
                id: item.id,
                name: item.name,

                photo_link: item.cover_image,

                assigner: item.assigner
                  ? item.assigner.fullname
                  : "-",

                is_compulsory: item.is_compulsory,

                total_user: item.assigned_user_count,
                not_started_users: item.not_started_user_count,
                started_users: item.in_progress_user_count,
                completed_users: item.completed_user_count,

                total_rating: item.total_rating,
                total_duration: item.total_duration,

                start_date: item.start_date
                  ? moment(item.start_date).format("DD.MM.YYYY HH:mm")
                  : "-",

                end_date: item.end_date
                  ? moment(item.end_date).format("DD.MM.YYYY HH:mm")
                  : "-",

                status: item.status_id === 1 ? "Aktif" : "Pasif",

                created_at: item.created_at
                  ? moment(item.created_at).format("DD.MM.YYYY HH:mm")
                  : "-",
              });
            });
          }
        });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;

      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    getFilter(value) {
      this.page = 1;
      this.filterResult(value);
    },
  },
  mounted() {
    this.filterResult();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);

    if (this.$route.params.succesMessage != null) {
      this.successMessage = this.$route.params.succesMessage;
      this.scrollToTop();
    }
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function (val) {
      this.page = 1;
      this.debouncedFilterSearch();
    },
    formattedInstitution(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker1").selectpicker();
        }, 200);
      }
    },
    formattedUserGroup(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker2").selectpicker();
        }, 200);
      }
    },
    formattedPosition(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker3")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },
    formattedTitle(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker4")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },
    formattedRegion(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker5")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },
    formattedDepartment(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker6")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },
    formattedBranch(value) {
      if (value) {
        setTimeout(() => {
          $(".selectpicker7")
            .selectpicker("refresh")
            .trigger("change");
        }, 200);
      }
    },
    activeItem(value) {
      if (value) {
        this.getUserDetail(value.id);
      }
    },
  },
  beforeDestroy() {
    const modal = UIkit.modal("#modal-profile");
    if (modal) modal.$destroy(true);
  },
};
</script>

<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
